import { ORG_LOOKUP_API_KEY } from "./constants";
import { CheckedEnvironment } from "./types";

async function checkCmsStatus(cmsUrl: string): Promise<"online" | "offline"> {
  try {
    const res = await fetch(cmsUrl, { method: "GET", mode: "cors" });
    return res.ok ? "online" : "offline";
  } catch {
    // CMS is a static SPA without CORS for this monitor origin. A successful
    // no-cors probe still means the host answered; network/DNS failure → offline.
    try {
      await fetch(cmsUrl, { method: "GET", mode: "no-cors" });
      return "online";
    } catch {
      return "offline";
    }
  }
}

export default async function checkStatus(
  organisation: string,
): Promise<CheckedEnvironment> {
  const domain = ".primio.app";
  const apiUrl = `https://api.${organisation}${domain}`;
  const cmsUrl = `https://cms.${organisation}${domain}`;

  const cmsStatusPromise = checkCmsStatus(cmsUrl);

  try {
    const res = await fetch(`${apiUrl}/health/`, {
      headers: {
        authorization: ORG_LOOKUP_API_KEY ? `Bearer ${ORG_LOOKUP_API_KEY}` : "",
      },
    });
    const status = res.ok ? "online" : "offline";

    let version: string | undefined;
    try {
      const openApiResponse = await fetch(`${apiUrl}/docs-json`);
      if (openApiResponse.ok) {
        const openApi = await openApiResponse.json();
        version = openApi?.info?.version;
      }
    } catch (_) {
      // ignore, version stays undefined
    }

    return {
      organisation,
      status,
      cmsStatus: await cmsStatusPromise,
      version,
    };
  } catch {
    return {
      organisation,
      status: "offline",
      cmsStatus: await cmsStatusPromise,
    };
  }
}
